<template>
  <div>
    <v-tooltip v-if="isLoggedIn" bottom>
      <template v-slot:activator="{ on }">
        <v-btn
            v-test="{ btn: 'notifications' }"
            icon
            v-on="on"
            @click.stop="openSubscriptionsDialog">
          <v-icon>
            {{ hasNotifications
              ? 'notifications'
              : 'notifications_off' }}
          </v-icon>
        </v-btn>
      </template>
      <span>
        {{ $t(hasNotifications
          ? 'Изменить подписки на рассылку'
          : 'Включить подписки на рассылку') }}
      </span>
    </v-tooltip>
    <subscriptions-dialog
        v-if="subscriptionsDialog.show"
        :subscriptions="subscriptions"
        :dialog-prop="subscriptionsDialog"
        @close="closeDialog('subscriptionsDialog')" />
  </div>
</template>

<script>
  import SubscriptionsDialog from '@/components/reused/common/SubscriptionsDialog.vue'
  import { SUBSCRIPTION_TYPES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { CURRENT_USER } from '@/constants/store.js'

  export default {
    components: {
      SubscriptionsDialog
    },
    data () {
      return {
        subscriptionsDialog: {
          show: false,
          callback: null
        }
      }
    },
    computed: {
      ...mapState(CURRENT_USER.NAMESPACE, {
        subscriptions: state => (state[CURRENT_USER.STATE.SUBSCRIPTIONS] || {}),
        hasNotifications: state => {
          const status = state[CURRENT_USER.STATE.SUBSCRIPTIONS_STATUS]
          return status && status !== SUBSCRIPTION_TYPES.NONE
        }
      })
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(CURRENT_USER.NAMESPACE, {
        getCurrentUserSubscriptionAction: CURRENT_USER.ACTIONS.GET_CURRENT_USER_SUBSCRIPTION,
        changeCurrentUserSubscriptionAction: CURRENT_USER.ACTIONS.CHANGE_CURRENT_USER_SUBSCRIPTION,
        clearCurrentUserSubscriptionAction: CURRENT_USER.ACTIONS.CLEAR_CURRENT_USER_SUBSCRIPTION
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearCurrentUserSubscriptionAction()
          ])
      },
      openSubscriptionsDialog: async function () {
        try {
          await this.getCurrentUserSubscriptionAction()
        } catch (error) {
          this.throwIfNotServerError(error)
        }
        this.subscriptionsDialog.callback = this.changeCurrentUserSubscription
        this.subscriptionsDialog.show = true
      },
      changeCurrentUserSubscription: async function (model) {
        this.isLoading = true
        try {
          await this.changeCurrentUserSubscriptionAction(model)
          await this.getCurrentUserInfo()
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
